import { Injectable } from '@angular/core';

import { FixturePage } from '@cds/betting-offer';
import { Observable } from 'rxjs';

import { BetBuilderApi as CdsBetbuilderApi } from '../../cds/betbuilder-api.service';

@Injectable({ providedIn: 'root' })
export class BetBuilderService {
    constructor(private betBuilderApi: CdsBetbuilderApi) {}

    getFixtures(sport: number, skip?: number, take?: number): Observable<FixturePage | undefined> {
        return this.betBuilderApi.getFixtures(sport, skip, take);
    }
}
